import { View } from "@/components/ui/view";
import { Divider } from "@/components/ui/divider";
import React, {useContext} from 'react';
import InputHandle from "../basic/InputHandle";
import OutputHandle from "../basic/OutputHandle";
import WebTimerInput from "../basic/WebTimerInput";
import NodeView from "./NodeView";
import {MediaContext} from "../media/MediaContext";


export default function WaitNode({id, data, selected}) {
    const {flowId, nodeHighlighting} = useContext(MediaContext)

    const updateTimer = (time) => {
        const newNodeData = {...data, timer: time}
        data.updateNode(id, newNodeData, false)
    }

    return (
        <NodeView id={id} data={data} selected={selected} disabled={flowId == 'showFlow'} nodeHighlighting={nodeHighlighting[id]}>
            <View className="rounded-b-md bg-primary-50">
                <Divider/>
                <WebTimerInput value={data.timer} setTime={updateTimer} disabled={data.disabled || flowId == 'showFlow'}/>
            </View>
            <InputHandle nodeHighlighting={nodeHighlighting[id]}/>
            <OutputHandle id='output' position={28} nodeHighlighting={nodeHighlighting[id]}/>
        </NodeView>
    );
}
